import { Box, Center, Heading, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { Brand } from "../brand/Brand";
import { ErrorContent } from "./ErrorContent";

interface IErrorProps {
    error: any;
}

export function Error(props: IErrorProps) {
    const { t } = useTranslation();
    useEffect(() => {
        console.warn("Error page rendered:", props.error);
    }, [props.error]);
    return (
        <VStack alignItems="stretch" w="full">
            <Box textAlign="center" py={10} px={6}>
                <Center color={"orange.300"} fontSize={"10em"}>
                    <Brand variant="cracked" />
                </Center>
                <Heading as="h2" size="xl" mt={4} mb={2}>
                    {t("error.title").toString()}
                </Heading>
                <Text color={"gray.500"}>{t("error.subtitle").toString()}</Text>
            </Box>
            <ErrorContent error={props.error} />
        </VStack>
    );
}
